import "@fae/source/index.less"
import "@fae/source/engine/testing/utility/node.js"
import "@fae/source/engine/testing/test.js"

////////////////
// Game Loop //
//////////////

import App from "@fae/source/models/App.js"
import Dev from "@fae/source/models/dev/Dev.js"

import Loop from "@fae/source/engine/Loop.js"
import Render from "@fae/source/engine/Render.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
import LogTime from "@fae/source/utility/LogTime.js"

Loop.start(function(delta) {
    Dev.atStartOfLoop()

    Audiomix.update(delta)
    App.update(delta)
    Render()

    Dev.atEndOfLoop()
})

////////////////
// Analytics //
//////////////

// import "@fae/source/analytics.js"

///////////////////
// Key Defaults //
/////////////////

window.addEventListener("keydown", (event) => {
    if(event.key == "s"
    && event.metaKey == true) {
        event.preventDefault()
    }
})

window.addEventListener("DOMContentLoaded", (event) => {
    // LogTime("DomContentLoaded Time")
    App.times = App.times || {}
    App.times.domload = window.performance.now()
})

window.addEventListener("load", (event) => {
    // LogTime("Full Load Time")
    App.times = App.times || {}
    App.times.load = window.performance.now()
})

window.addEventListener("mouseup", (event) => {
    event.preventDefault()
})

window.addEventListener("keydown", (event) => {
    if(event.altKey == true
    || event.metaKey == true) {
        event.preventDefault()
    }
})

window.addEventListener("error", (event) => {
    App.errors = App.errors || []
    App.errors.push(event.error)
})

window.addEventListener("beforeunload", (event) => {
    return "Are you sure you want to leave the page? You will lose all progress."
})
